module.exports = __webpack_public_path__ + "0a4bd8b8d24bff0087adea0b1015b409.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile23.png
// module id = 1884
// module chunks = 0